import { useGovernanceOptional } from './GovernanceProvider'
import { durableStatusLine } from './governanceDurable'
import type { DurableMode } from './governanceModel'

const MODE_VAR: Record<DurableMode, string> = {
  durable: 'var(--govv-verified)',
  auth_required: 'var(--govv-attention)',
  unavailable: 'var(--govv-denied)',
  local: 'var(--govv-attention)',
}

/**
 * DurableSourceBanner — the honest data-reality line for a governance surface.
 * States whether the durable canonical sources (olv_audit_trail, integrity
 * chain) are live-and-authed, auth-required, or demo/local — so no operator
 * mistakes the local-session ledger for durable data.
 */
export default function DurableSourceBanner() {
  const gov = useGovernanceOptional()
  if (!gov) return null
  const status = gov.state.durable
  const mode: DurableMode = status?.mode ?? 'local'
  return (
    <div role="note" aria-label="Data source status" style={{
      display: 'flex', alignItems: 'center', gap: 8,
      border: '1px solid var(--govv-line)', borderLeft: `3px solid ${MODE_VAR[mode]}`,
      borderRadius: 'var(--sc-radius-md)', padding: '8px 12px', marginBottom: 16,
      background: 'var(--govv-panel)',
    }}>
      <span aria-hidden style={{ width: 8, height: 8, borderRadius: '50%', background: MODE_VAR[mode], flexShrink: 0 }} />
      <span style={{ fontSize: 12, color: 'var(--govv-ink-2)' }}>{durableStatusLine(status)}</span>
    </div>
  )
}
